module.exports = __webpack_public_path__ + "static/media/miniSpinner.0890a265.gif";